<template>
  <el-table
    :data="tableData"
    border
    fit
    highlight-current-row
    style="width: 100%"
    v-loading="loading"
  >
    <el-table-column
      prop="dataTime"
      label="日期"
      align="center"
    />
    <el-table-column
      prop="prodName"
      label="商品名称"
      align="center"
    />
    <el-table-column
      prop="salesRevenue"
      label="销售收入"
      align="center"
    />
    <el-table-column
      prop="salesCost"
      label="销售成本"
      align="center"
    />
    <el-table-column
      prop="grossMargin"
      label="销售毛利"
      align="center"
    />
    <el-table-column
      prop="lossMoney"
      label="亏损金额"
      align="center"
    />
    <el-table-column
      prop="createTime"
      label="创建时间"
      align="center"
    />
  </el-table>
</template>

<script>
export default {
  name: 'SellingCostDetailTable',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table {
  margin-top: 20px;
}
</style>